import { type RefObject, useEffect, useRef } from "react";

interface IUseKeepQueryInViewProps {
  selectedCount: number;
}

// NOTE: NSAI-7350 — the chip row is capped (`max-h-20`) and scrolls, and the
// query input is its last item. Each pick appends a chip ahead of the input, so
// past a few rows the input slides below the visible area while it still holds
// focus, and whatever the user types next is invisible. Growing the selection
// scrolls the row to its end, where the input is; removing a chip leaves the
// scroll position alone so the user keeps their place among the chips.
export const useKeepQueryInView = ({
  selectedCount,
}: IUseKeepQueryInViewProps): RefObject<HTMLDivElement> => {
  const chipRowRef = useRef<HTMLDivElement>(null);
  const previousCountRef = useRef(selectedCount);

  useEffect((): void => {
    const chipRow = chipRowRef.current;
    if (chipRow && selectedCount > previousCountRef.current) {
      chipRow.scrollTop = chipRow.scrollHeight;
    }
    previousCountRef.current = selectedCount;
  }, [selectedCount]);

  return chipRowRef;
};
